import React, { useState } from 'react';
import {
  Avatar, Button, CssBaseline, TextField, Container, CircularProgress, colors, Typography, makeStyles,
  FormControlLabel, Checkbox, Link, Grid, Snackbar
} from '@material-ui/core';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { Register } from '../../../fetchs';
import { withRouter } from 'react-router-dom';
import '../Login/login.styles.css'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  buttonProgress: {
    color: colors[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

function SignUp(props) {
  const [openState, setOpenState] = useState(false);
  const [loading, setLoading] = useState(false);
  const classes = useStyles();

  function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    Register({
      userName: e.target.userName.value,
      password: e.target.password.value,
      phoneNumber: e.target.phoneNumber.value,
    })
      .then(response => {
        setLoading(false);
        if (response.status === 401) {
          setOpenState(true);
          return;
        }

        if (response.status === 400) {
          setOpenState(true);
          return;
        }
        return response.json();
      })
      .then(responseJson => {
        if(responseJson === undefined){
          setOpenState(true);
          return;
        }
        // localStorage.setItem('apiKey', responseJson.token);
        // localStorage.setItem('userData', JSON.stringify(responseJson));
        props.history.push('/login');
      })
      .catch(error => {
        setLoading(false);
        console.error(error);
      });
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          ثبت نام در وب سایت زیستاگرام
        </Typography>
        <form className={classes.form} noValidate onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="userName"
            label="نام کاربری"
            name="userName"
            autoComplete="userName"
            autoFocus
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="رمز عبور"
            type="password"
            id="password"
            autoComplete="current-password"
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="phoneNumber"
            label="شماره همراه"
            type="text"
            id="phoneNumber"
            autoComplete="phoneNumber"
          />
          {/* <FormControlLabel
            control={<Checkbox value="remember" color="primary" />}
            label="مرا به خاطر نگهدار"
          /> */}
          <div className={classes.wrapper}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              disabled={loading}
            >
              ورود
            </Button>
            {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
          </div>
          {/* <Grid container>
            <Grid item xs>
              <Link href="#" variant="body2">
                فراموشی رمز عبور
              </Link>
            </Grid>
            <Grid item>
              <Link href="#" variant="body2">
                {"حساب کاربری ندارید؟ ثبت نام کنید"}
              </Link>
            </Grid>
          </Grid> */}
        </form>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        autoHideDuration={3000}
        open={openState}
        ContentProps={{
          'aria-describedby': 'message-id',
          'class': 'error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2'
        }}
        message={<span id="message-id"> امکان ثبت کاربر وجود ندارد</span>}
        onClose={() => setOpenState(false)} />
    </Container>
  );
}

export default withRouter(SignUp);